import styled from "styled-components/macro";
import { Box, Card as MuiCard, CardContent as MuiCardContent, Fade, Typography } from "@material-ui/core";
import TableStats from "./components/TableStats";
import DoughnutChart from "./components/DoughnutChart";
import React, { FC } from "react";
import NoDataAvailable from "./components/NoDataAvailable";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)`
        border-radius: 14px
    `;
const CardContent = styled(MuiCardContent)`
        padding: 0;
        position: relative;
        &:last-child {
            padding-bottom: 0
        }
    `;

type PropsType = {
  data: {
    [key: string]: number
  },
}

const VisitorsInteractionWithTheWidget:FC<PropsType> = ({data}) => {
  const { t } = useTranslation();
  const haveData = data && Object.keys(data).length > 0

  const sortData = () => Object.entries(data)
      .sort(([,a],[,b]) => b-a)

  const tableData = {
    names: [
      t("statsPage_action"),
      t("statsPage_clicks")
    ],
    rows: haveData ? sortData().map((i) => {
      return {name: i[0], value: i[1]}
    }) : []
  }

  const doughnutData = {
    labels: haveData ? sortData().map((i) => i[0]) : [],
    data: haveData ? sortData().map((i) => i[1]): []
  }

  return (
    <Fade in={true}>
      <Card>
        <CardContent>
          <Box p={4}>
            <Typography>
              {t("statsPage_visitorsInteraction")}
            </Typography>
          </Box>
          <Loading loading={!data} height={386}>
            <Box>
              <Box mb={4}>
                <DoughnutChart labels={doughnutData.labels} data={doughnutData.data} borderWidth={3}/>
              </Box>
              <Box mb={3}>
                <TableStats headNames={tableData.names} rows={tableData.rows} height={250}/>
              </Box>
              <NoDataAvailable visible={!haveData}/>
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}

export default VisitorsInteractionWithTheWidget
